import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Button,
  Row,
  Avatar,
  Layout,
  Form,
  Input,
  Upload,
} from "antd";
import { useNavigate } from "react-router";
import { UPLOADS_URL, COACH } from "../../config/constants/api";
import { Post } from "../../config/api/post";
import { addUser } from "../../redux/slice/authSlice";
import { CONTENT_TYPE } from "../../config/constants/index";
import swal from "sweetalert";
import { TbCameraPlus } from "react-icons/tb";
import { ImageUrl } from "../../helpers/Functions";
import "./profile.css";

const navItems = [
  { label: "Profile", path: "/profile" },
  { label: "Education", path: "/education" },
  { label: "Meetings", path: "/meetings" },
  { label: "Subjects", path: "/subjects" },
  { label: "Services", path: "/services" },
  { label: "Hourly Rates", path: "/rates" },
  { label: "Rating & Review", path: "/review" },
  { label: "My Meetings", path: "/my-meetings" },
  { label: "My Assesments", path: "/my-assesments" },
];

function Profile() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [editMode, setEditMode] = useState(false);
  const [imageNew, setImageNew] = useState();

  React.useEffect(() => {
    if (!token) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const onFinish = (values) => {
    const formObject = new FormData();

    if (imageNew) {
      formObject.append("image", values.image.fileList[0].originFileObj);
    }

    for (const key in values) {
      if (key !== "image") {
        const item = values[key];
        formObject.append(key, item);
      }
    }

    Post(COACH.updateProfile, formObject, token, null, CONTENT_TYPE.FORM_DATA)
      .then((response) => {
        if (response?.data?.status) {
          dispatch(addUser({ user: response.data.data, token: token }));
          swal("Success!", "Profile Updated Successfully", "success");
          setEditMode(false);
          setImageNew();
        } else {
          swal("Oops!", response.data.message, "error");
        }
      })
      .catch(() => {});
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const avatarSrc = imageNew
    ? imageNew
    : !user?.image
      ? ImageUrl("avatar.png")
      : UPLOADS_URL + "/" + user.image;

  const viewFields = [
    { label: "ID", value: user?._id },
    { label: "First Name", value: user?.firstName },
    { label: "Last Name", value: user?.lastName },
    { label: "Email", value: user?.email },
    { label: "Phone Number", value: user?.phone },
    { label: "Present Address", value: user?.address },
    { label: "City", value: user?.city },
    { label: "State", value: user?.state },
    { label: "Zip Code", value: user?.zip },
    {
      label: "Social Security Number or Tax ID Number",
      value: user?.socialSecurity,
    },
    { label: "Phone Number", value: user?.homeNumber },
    { label: "Mobile Number", value: user?.alternatePhone },
    { label: "Tag Line", value: user?.tagLine },
    { label: "Detailed Bio", value: user?.bio, wide: true },
  ];

  return (
    <Layout className="profile-page">
      <section className="profile-hero">
        <div className="profile-wrap profile-hero-inner">
          <h1 className="fontFamily1 profile-hero-title">My Profile</h1>
          <p className="fontFamily1 profile-hero-sub">
            View and update your personal details, contact info, and trainer
            profile.
          </p>
        </div>
      </section>

      <div className="profile-wrap profile-main">
        <div className="profile-layout">
          <aside className="profile-nav">
            <p className="profile-nav-title">Account</p>
            <ul className="profile-nav-list">
              {navItems.map((item) => (
                <li key={item.path}>
                  <button
                    type="button"
                    className={`profile-nav-item${
                      item.path === "/profile" ? " is-active" : ""
                    }`}
                    onClick={() => navigate(item.path)}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </aside>

          <section className="profile-panel">
            <div className="profile-panel-head">
              <div>
                <h2 className="fontFamily1 profile-panel-title">
                  Profile Details
                </h2>
                <p className="profile-panel-sub">
                  {editMode
                    ? "Update your information and save changes."
                    : "Your current profile information."}
                </p>
              </div>
            </div>

            <Form
              layout="vertical"
              name="basic"
              className="contactForm profile-form"
              labelCol={{ span: 0 }}
              wrapperCol={{ span: 24 }}
              initialValues={{ remember: true }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <div className="profile-avatar-wrap">
                {editMode ? (
                  <Form.Item name="image" style={{ marginBottom: 0 }}>
                    <Upload
                      name="image"
                      showUploadList={false}
                      beforeUpload={(file) => {
                        setImageNew(URL.createObjectURL(file));
                        return false;
                      }}
                    >
                      <span className="profile-avatar-cam" aria-hidden>
                        <TbCameraPlus />
                      </span>
                      <Avatar size={160} src={avatarSrc} />
                    </Upload>
                  </Form.Item>
                ) : (
                  <Avatar size={160} src={avatarSrc} />
                )}
              </div>

              {editMode ? (
                <>
                  <Row gutter={20}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="First Name*"
                        name="firstName"
                        initialValue={user.firstName}
                        rules={[
                          {
                            required: true,
                            message: "Please input your first name",
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder="Enter FullName"
                          className="signupFormInput"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Last Name*"
                        name="lastName"
                        rules={[
                          {
                            required: true,
                            message: "Please input your last name",
                          },
                        ]}
                        initialValue={user.lastName}
                      >
                        <Input
                          size="large"
                          placeholder="Enter LastName"
                          className="signupFormInput"
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Email*"
                        name="email"
                        rules={[
                          {
                            required: true,
                            message: "Please input your email",
                          },
                        ]}
                        initialValue={user.email}
                      >
                        <Input
                          size="large"
                          disabled
                          placeholder="Enter Email Address"
                          className="signupFormInput"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Phone Number*"
                        name="phone"
                        rules={[
                          {
                            required: true,
                            message: "Please input phone number",
                          },
                        ]}
                        initialValue={user.phone}
                      >
                        <Input
                          size="large"
                          placeholder="Enter Phone Number"
                          className="signupFormInput"
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Present Address*"
                        name="address"
                        rules={[
                          {
                            required: true,
                            message: "Please input preasent address",
                          },
                        ]}
                        initialValue={user.address}
                      >
                        <Input
                          size="large"
                          placeholder="Enter Address"
                          className="signupFormInput"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="City*"
                        name="city"
                        rules={[
                          {
                            required: true,
                            message: "Please input city name",
                          },
                        ]}
                        initialValue={user.city}
                      >
                        <Input
                          size="large"
                          placeholder="Enter City"
                          className="signupFormInput"
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="State*"
                        name="state"
                        rules={[
                          {
                            required: true,
                            message: "Please input state",
                          },
                        ]}
                        initialValue={user.state}
                      >
                        <Input
                          size="large"
                          placeholder="Enter State"
                          className="signupFormInput"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label={
                          <>
                            Zip Code <span className="redStar">*</span>
                          </>
                        }
                        name="zip"
                        rules={[
                          {
                            required: true,
                            message: "Please input zip code",
                          },
                        ]}
                        initialValue={user.zip}
                      >
                        <Input
                          size="large"
                          placeholder="Enter Zip Code"
                          className="signupFormInput"
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Tag Line*"
                        name="tagLine"
                        rules={[
                          {
                            required: true,
                            message: "Please enter tag line",
                          },
                        ]}
                        initialValue={user.tagLine}
                      >
                        <Input
                          size="large"
                          placeholder="Enter TagLine"
                          className="signupFormInput"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Phone Number*"
                        name="homeNumber"
                        rules={[
                          {
                            required: true,
                            message: "Please enter phone number",
                          },
                        ]}
                        initialValue={user.homeNumber}
                      >
                        <Input
                          size="large"
                          placeholder="Enter phone number"
                          className="signupFormInput"
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Social Security Number or Tax ID Number**"
                        name="socialSecurity"
                        rules={[
                          {
                            required: true,
                            message:
                              "Please input social security or Tax ID Number",
                          },
                        ]}
                        initialValue={user.socialSecurity}
                      >
                        <Input
                          size="large"
                          placeholder="Enter social security or Tax ID Number"
                          className="signupFormInput"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Mobile Number*"
                        name="alternatePhone"
                        rules={[
                          {
                            required: true,
                            message: "Please enter mobile number",
                          },
                        ]}
                        initialValue={user.alternatePhone}
                      >
                        <Input
                          size="large"
                          placeholder="Enter mobile number"
                          className="signupFormInput"
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Detailed Bio*"
                        name="bio"
                        rules={[
                          {
                            required: true,
                            message: "Please input your bio",
                          },
                        ]}
                        initialValue={user.bio}
                      >
                        <Input.TextArea
                          size="large"
                          placeholder="Enter Detailed Bio"
                          className="signupFormInput ContactFormInput2"
                          rows={4}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <div className="profile-actions">
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="profile-btn-primary"
                    >
                      Update Profile
                    </Button>
                    <Button
                      className="profile-btn-ghost"
                      ghost
                      size="large"
                      onClick={(e) => {
                        e.preventDefault();
                        setEditMode(false);
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </>
              ) : (
                <div className="profile-fields">
                  {viewFields.map((field, index) => (
                    <div
                      key={`view-field-${index}`}
                      className={`profile-field${
                        field.wide ? " profile-field--wide" : ""
                      }`}
                    >
                      <p className="profile-field-label">{field.label}</p>
                      <p className="profile-field-value">
                        {field.value || "—"}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </Form>

            {!editMode && (
              <div className="profile-actions">
                <Button
                  type="primary"
                  htmlType="button"
                  className="profile-btn-primary"
                  onClick={() => setEditMode(true)}
                >
                  Edit Profile
                </Button>
                <Button
                  className="profile-btn-ghost"
                  ghost
                  size="large"
                  onClick={() => navigate("/change-password")}
                >
                  Change Password
                </Button>
              </div>
            )}
          </section>
        </div>
      </div>
    </Layout>
  );
}

export default Profile;
